module.exports = __webpack_public_path__ + "img/ic-arrow-right.f49e20f8.svg";